const SDSearchCore = (() => {
  const roles = ['equipment', 'accessories', 'parts'];
  const normalize = value => String(value || '').normalize('NFKC').trim().toLowerCase();
  const barcode = value => {
    const cleaned = normalize(value).replace(/[\s-]/g, '');
    return /^\d{8,14}$/.test(cleaned) ? cleaned : '';
  };
  function identifiers(catalog) {
    const maps = {sku: new Map(), barcode: new Map(), model: new Map(), alias: new Map()};
    const add = (kind, value, target) => {
      const key = kind === 'barcode' ? barcode(value) : normalize(value);
      if (!key) return;
      if (!maps[kind].has(key)) maps[kind].set(key, []);
      maps[kind].get(key).push(target);
    };
    for (const product of catalog.products) {
      add('model', product.model, {product});
      for (const alias of product.aliases || []) add('alias', alias, {product});
      for (const variant of product.variants) {
        const target = {product, variant};
        add('sku', variant.sku, target);
        add('barcode', variant.barcode, target);
        add('model', variant.model, target);
      }
    }
    return maps;
  }
  function exact(maps, value) {
    const normalized = normalize(value);
    const upc = barcode(value);
    const matches = maps.sku.get(normalized) || (upc && maps.barcode.get(upc)) || maps.alias.get(normalized) || maps.model.get(normalized);
    if (!matches?.length || new Set(matches.map(match => match.product.id)).size !== 1) return null;
    const variants = [...new Map(matches.filter(match => match.variant).map(match => [match.variant.id, match.variant])).values()];
    return {product: matches[0].product, variant: variants.length === 1 ? variants[0] : null};
  }
  function rankMatches(matches) {
    const unique = [...new Map(matches.map(match => [match.id, match])).values()];
    return unique.sort((left, right) => left.tier - right.tier);
  }
  return {roles, normalize, barcode, identifiers, exact, rankMatches};
})();
if (typeof module !== 'undefined' && module.exports) module.exports = SDSearchCore;
if (typeof window !== 'undefined') window.SDSearchCore = SDSearchCore;
